/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_State_Select_TitleInputs */



/**
* | output |
* | --- |
* | "Select new state" |
*
* @param {Explorer_Info_State_Select_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_state_select_title = /** @type {((inputs?: Explorer_Info_State_Select_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_State_Select_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner un nouvel etat")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuen Staat auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un nuovo stato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите новый штат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar nuevo estado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择新状态")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい状態を選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया राज्य चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o novo estado")
	return /** @type {LocalizedString} */ ("Select new state")
});